<template>
        <b-modal :static="true" :title="Core.Definition.getDefinition('Nouveau billet de support')" v-model="dataShow"  :hide-footer="true">
            <p>
                {{Core.Definition.getDefinition('Nous sommes là pour vous aider. Envoyez-nous votre demande, un membre de notre équipe vous répondra dès que possible.')}}
            </p>
            <DynamicForm
                    v-if="dataTicketCreated === false"
                    ref="dynamicForm"
                    getRoot="/support/ticket"
                    saveRoot="/support/ticket"
                    @onSaveSuccess="onSaveSuccess"
                    :formStructure="dataFormStructure">
            </DynamicForm>

            <b-row v-if="dataTicketCreated">
                <b-col>
                    <b-alert show class="alert alert-success">
                        {{Core.Definition.getDefinition('Votre demande à été envoyée. Un membre de notre équipe vous contactera sous peu.')}}
                    </b-alert>
                </b-col>
            </b-row>

        </b-modal>
</template>

<script>
    import Request from '../components/Request'
    import DynamicForm from '../components/DynamicForm'
    import Alert from '../components/Alert'
    export default {
        name: 'ModalSupport',
        components: {
            Request,
            Alert,
            DynamicForm
        },
        props: {},
        watch: {},
        mounted() {
        },
        data: () => {
            return {
                Core: window.Core,
                dataShow: false,
                dataTicketCreated: false,
                dataFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'subject'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'category'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'description'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'subject',
                            type: 'text',
                            required: true,
                            label: Core.Definition.getDefinition('Sujet'),
                            value: ''
                        },
                        {
                            id: 'category',
                            type: 'select',
                            required: true,
                            search: false,
                            label: Core.Definition.getDefinition('De quoi s\'agit-il?'),
                            value: '',
                            options: Core.Support.categoryOptions(),
                            onSelect: function(value, form, fieldRefs) {
                            }
                        },
                        {
                            id: 'description',
                            type: 'longText',
                            required: true,
                            label: Core.Definition.getDefinition('Description'),
                            value: ''
                        }
                    ]
                }
            }
        },
        computed: {
            open: {
                set(val) {
                    this.dataTicketCreated = false
                    this.dataShow = val
                },
                get() {
                    return this.dataShow
                }
            }
        },
        methods: {
            onSaveSuccess() {
                this.dataTicketCreated = true
                this.$emit('onTicketCreated')
            }
        }
    }
</script>